import React, { Component } from "react";
import _ from "lodash";
import Password from "./password";
import TranscriptionTest from "./transcriptionTest";
import Nda from "./nda";
import Privacy from "./privacy";
import Slack from "./slack";
import Breadcrumb from "./breadcrumb";
import SiteVideo from "./siteVideo";
import Payment from "./payment";
import Faq from "./faq";
import Training from "./training";
import Transcribing from "./transcribing";
import ScoringExam from "./scoringExam";
import ScoringSubmitted from "./scoringSubmitted";
import ScoringInterview from "./scoringInterview";
import Scoring from "./scoring";

export const helpMessage = isScorer => isScorer ?
<React.Fragment>Need help? Reach out to <a href="mailto:mitch@qa-world.com" target="_blank"  rel="noopener noreferrer">mitch@qa-world.com</a></React.Fragment> :
  <React.Fragment>Need help? Reach out to #helpdesk on Slack or <a href="https://www.facebook.com/qaworldcommunity/" target="_blank"  rel="noopener noreferrer">Contact us on Facebook</a></React.Fragment>

class Onboarding extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  render() {
    const {
      currentContractor,
      privacyQuiz,
      faqQuiz,
      updateOnboardingStep,
      transcriptionTest,
      updateTranscriptionTest,
      steps,
      scoringExam,
    } = this.props;

    if (currentContractor.onboardingStep == null) {
      window.location.href = '/calls';
      return null;
    }

    const componentsConfiguration = {
      "password": {
        component: Password,
      },
      "transcription_test": {
        component: TranscriptionTest,
        props: { transcriptionTest, updateTranscriptionTest }
      },
      "nda": {
        component: Nda,
      },
      "privacy": {
        component: Privacy,
        props: { privacyQuiz },
      },
      "site_video": {
        component: SiteVideo,
      },
      "slack": {
        component: Slack,
      },
      "payment": {
        component: Payment,
      },
      "faq": {
        component: Faq,
        props: { faqQuiz },
      },
      "training": {
        component: Training,
      },
      "transcribing": {
        component: Transcribing,
      },
      "scoring_exam": {
        component: ScoringExam,
        props: { scoringExam },
        width: '1000px',
      },
      "scoring_submitted": {
        component: ScoringSubmitted,
      },
      "scoring_interview": {
        component: ScoringInterview,
      },
      "scoring": {
        component: Scoring,
      }
    };

    const conf = componentsConfiguration[currentContractor.onboardingStep.name];
    const OnboardingComponent = conf.component;
    const onboardingProps = conf.props || {};
    const activeOnboardingIndex = steps.findIndex(step => step.name === currentContractor.onboardingStep.name);
    const breakOnboardingIndex = steps.findIndex(step => step.name === 'scoring_interview' || step.name === 'site_video') + 1;
    const isBroken = activeOnboardingIndex >= breakOnboardingIndex;

    return (
      <div className="onboarding-container">
        <div className="onboarding-body" style={{width: conf.width || '800px'}}>
        <div className="onboarding-body-inner">
            { activeOnboardingIndex >= 0 &&
                <div className="onboarding-breadcrumb-container">
                  {
                    steps.map((step, i) => {
                      if ((isBroken && i >= breakOnboardingIndex) || (!isBroken && i < breakOnboardingIndex)) {
                        return (
                          <Breadcrumb title={step.display_name} isInProgress={i==activeOnboardingIndex} isFinished={i<activeOnboardingIndex} key={step.name} />
                        );
                      }
                    })
                  }
                </div>
            }
            <OnboardingComponent {...onboardingProps} currentContractor={currentContractor} updateOnboardingStep={updateOnboardingStep}/>
          </div>
          <div className="onboarding-footer onboarding-biglabel">
            {helpMessage(!currentContractor.transcribe_only)}
          </div>
        </div>
      </div>
    );
  }
}

export default Onboarding;
